import React from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import { movePreviousOrderToCartForEdit } from "utils"

const OrderDetailsCheckoutButton = props => {
  const { order, subPaymentItems } = props

  const [t] = useTranslation()

  const history = useHistory()

  const handlePress = () => {
    movePreviousOrderToCartForEdit(
      order,
      order.tableNumber,
      subPaymentItems || {}
    )

    history.push("/checkout")
  }

  return (
    <Button
      fullWidth
      color="success"
      onClick={handlePress}
    >
      {t("پرداخت")}
    </Button>
  )
}

export default OrderDetailsCheckoutButton